/**
 * Show sticky-bar on scroll
 * Only applies if page-menu-bar is not enabled
 */

((window, document) => {
	const stickyBar = document.querySelector('#sticky-bar.visible-on-scroll');
	
	if (!stickyBar) {
		return;
	}

	const visibilityTrigger = stickyBar.hasAttribute('data-visible-top-anchor') ? stickyBar.getAttribute('data-visible-top-anchor') : '.page-container';
	// console.log('visibilityTrigger:', visibilityTrigger);

	// Find the container that should trigger the visibility
	let triggerContainer = document.querySelector(visibilityTrigger);
	// console.log('triggerContainer:', triggerContainer);

	if (!triggerContainer) {
		return;
	}

	function checkScrollPosition() {
		const containerRect = triggerContainer.getBoundingClientRect();
		const containerTop = containerRect.top;
		// console.log('containerTop', containerTop)
		// Show when container top reaches or passes the top of the viewport
		if (containerTop <= 0) {
			stickyBar.classList.add('is-visible');
		} else {
			stickyBar.classList.remove('is-visible');
		}
	}

	// Check on scroll
	window.addEventListener('scroll', checkScrollPosition, { passive: true });

	// Check on resize (in case layout changes)
	window.addEventListener('resize', checkScrollPosition, { passive: true });

	// Check on load, after dynamic content has rendered (e.g. Foundation Interchange)
	window.addEventListener('load', checkScrollPosition, { once: true });

	// Re-check each time Interchange swaps content, in case banner height changes.
	document.addEventListener('replaced.zf.interchange', checkScrollPosition);

})(window, document);

